import { useEffect } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

import { SECTION } from 'src/constants/section';
import trackEvent from 'src/services/analytics/trackEvent';

/**
 * Sends a page view usage event to the backend.
 */
const usePageTracking = (section: SECTION, route: string) => {
  const { pathname } = useLocation();
  // Each dashboard is its own module, so its slug tells the dashboards apart.
  const dashboard = useRouteMatch<{ slug?: string }>(route)?.params.slug;

  useEffect(() => {
    if (section === SECTION.PUBLIC) {
      return;
    }

    trackEvent('page_viewed', {
      module: SECTION[section].toLowerCase(),
      route,
      ...(section === SECTION.DASHBOARD && dashboard && { dashboard }),
    });
  }, [section, route, pathname, dashboard]);
};

export default usePageTracking;
